import { object } from 'prop-types'
import { graphql } from 'gatsby'

import EnhancedListProvider from '@/context/EnhancedList'
import Developers from '@/components/Developers'
import SEO from '@/components/SEO'
import { filterOutInvalidDevelopers } from '@/utils/products'
import { SORT_DEVS } from '@/constants'
import Layout from '@/layout'

const DevelopersPage = ({ data: { allDeveloper } }) => {
  const allDevelopers = allDeveloper.nodes
  const sortOptions = Object.values(SORT_DEVS)

  const validDevelopers = allDevelopers.filter(filterOutInvalidDevelopers)

  return (
    <EnhancedListProvider
      items={validDevelopers}
      defaultSortValue={SORT_DEVS.PRODUCTS_NUMBER.VALUE}
      defaultSortOptions={sortOptions}
    >
      <Layout headerLabel="Developers">
        <Developers />
      </Layout>
    </EnhancedListProvider>
  )
}

DevelopersPage.propTypes = {
  data: object,
}

export default DevelopersPage

export const Head = () => (
  <SEO
    title="LiveChat Marketplace Developers"
    description="The developers on the LiveChat Marketplace are a community of talented professionals
 who have created a variety of integrations and extensions that can help businesses 
 streamline their customer service processes and improve the overall customer experience."
    path="/developers/"
  />
)

export const query = graphql`
  query {
    allDeveloper(filter: { company: { ne: "" }, bio: { ne: "" } }) {
      nodes {
        id
        company
        website
        bio
        slug
        services {
          name
          id
          installations
          hidden
          logo {
            ...ProductSmallLogo
          }
          icons {
            small
            title
          }
        }
        apps {
          name
          id
          installations
          hidden
          logo {
            ...ProductSmallLogo
          }
          icons {
            small
            title
          }
        }
      }
    }
  }
`
